import { IUserPicklist } from "./IUserPicklist";

type UnregisterUserPicklistCallback = () => void;

export interface IUserPicklistRegistry {
    registerUserPicklist(name: string, userPicklist: IUserPicklist): UnregisterUserPicklistCallback;
    getUserPicklist(name: string): IUserPicklist | undefined;
}

export class UserPicklistRegistry implements IUserPicklistRegistry {
    private readonly picklists = new Map<string, IUserPicklist>();

    public registerUserPicklist(name: string, userPicklist: IUserPicklist): UnregisterUserPicklistCallback {
        if (this.picklists.has(name)) {
            throw new Error(`Picklist with name '${name}' already registered`);
        }
        this.picklists.set(name, userPicklist);
        return () => {
            this.picklists.delete(name);
        };
    }

    public getUserPicklist(name: string): IUserPicklist | undefined {
        return this.picklists.get(name);
    }
}
